<template>
    <nav class="wp-navi">
        <ul v-if="menu">
            <li v-for="(item, i) in menu" :key="i">
                <wpLink 
                    :url="item.url" 
                    :title="item.title"
                    :class="item.class"
                    :description="item.description"
                    v-html="item.title" />
            </li>
        </ul>
    </nav>
</template>

<script>
import wpLink from '@/components/navigation/WpLink'

import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'wp-navi',
    props: {
        location: {
            type: String/Number,
            default: 'primary-menu',
            required: true
        }
    },
    components: {
        wpLink
    },
    data(){
        return {
            menu: null,
            openNav: false,
        }
    },
    computed: {
        ...mapGetters([
            'getNavigation'
        ])
    },
    methods: {
        ...mapActions([
            'loadNavigation'
        ]),
        initNavigation(){
            const VM = this
            let menu = VM.getNavigation(VM.location)

            if(!menu) VM.loadNavigation(VM.location).then(res => VM.menu = res)
            VM.menu = menu
        }
    },
    mounted() {
        this.initNavigation()
    },
}
</script>